import { MenuItemOption } from "@components/common/mobile/mobile-types";
import { SdbMemberTypes } from "@custom-types/member-types";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { toggleItemSelection } from "@utils/array-utils";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { InfoIcon, SelectionIcon } from "@flat-ui";
import { useMembersUtils } from "@hooks/use-member-utils";

/** Hook to get the menu options for group members in mobile view */
export function useGroupMembersMenuOptionsMobile(): MenuItemOption<SdbMemberTypes>[] {
  const dispatch = useAppDispatch();
  const { openProfilePage } = useMembersUtils();

  const selectedRowIds = useAppSelector(selectedRowIdsSelector);

  const menuOptions: MenuItemOption<SdbMemberTypes>[] = [
    {
      label: "Select member",
      Icon: SelectionIcon,
      onSelect: (member) => {
        const newSelectedRowIds = toggleItemSelection(
          selectedRowIds,
          member.identity
        );
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      },
      shouldShowDividerAfter: true,
    },
    {
      label: "Profile",
      Icon: InfoIcon,
      onSelect: (member) => {
        openProfilePage({
          member,
          source: "user more info menu mobile",
        });
      },
    },
  ];

  return menuOptions;
}
